export const isExternalLink = (href) => !!href && !href.startsWith('#') && !href.startsWith('/');
//# sourceMappingURL=is-external-link.js.map